import { Link } from "react-router-dom";
import React, { useContext, useEffect, useState, useRef } from "react";
import "./MiscBannerv2.scss";
import SearchIcon from "@material-ui/icons/Search";
import { Button, IconButton } from "@material-ui/core";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import DispatchContext from "../../DispatchContext";
import LoginDialog from "../LoginDialog";
import SignUpDialog from "../SignUpModal";
import StateContext from "../../StateContext";
import PersonIcon from "@mui/icons-material/Person";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import LoginModal from "../loginModal/loginModal";
import kuwaitFlag from "../../Assets/images/kuwaitinput.png"
import { withTranslation, useTranslation, Trans } from "react-i18next";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import IosShareIcon from "../../Assets/images/IosShareIconPink.svg";
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import QRCodeStyling from "qr-code-styling";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Tooltip from '@mui/material/Tooltip';
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { RWebShare } from "react-web-share";
import logout from "../../Assets/images/Log-out2.svg"
import { erase, setCookie } from "../../Functions/cookieFunction";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
const qrCode = new QRCodeStyling({
  width: 200,
  height: 200,

  dotsOptions: {
    color: "#eb5b5e",
    type: "dot"
  },
  imageOptions: {
    crossOrigin: "anonymous",
    margin: 20
  }
});

const MiscBannerv2 = ({ children, cover, store, type, invoiceDetails, amount, handleAmount }) => {
  // const appDispatch = useContext(DispatchContext);
  const [url, setUrl] = useState("");
  const [fileExt, setFileExt] = useState("png");
  const ref = useRef(null);
  const appState = useContext(StateContext);
  const appDispatch = useContext(DispatchContext);
  const [alertMessage, setAlertMessage] = useState({
    open: false,
    message: "",
  });
  const [openQrCode, setOpenQrCode] = React.useState(false);
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    appDispatch({ type: "setLoginModal", loginModal: false });
  };

  const [openLogin, setOpenLogin] = useState(false);
  const [openSignUp, setOpenSignUp] = useState(false);
  const handleClickOpenLogin = () => {
    // appDispatch({ type: "setLoginModal", loginModal: true });
    var pay_url = window.location.href
    var auth_url = `${process.env.REACT_APP_AUTH_URL}`
    window.location.replace(auth_url + `?redirect=` + pay_url);
  };
  const handleClickOpenSignUp = () => {
    // appDispatch({ type: "setSignUpPhoneModal", signUpPhoneModal: true });
    var shop_url = window.location.href
    var auth_url = `${process.env.REACT_APP_AUTH_URL}`
    setCookie(`redirect`, shop_url);
    window.location.replace(auth_url);
  };
  const handleCloseLogin = () => {
    setOpenLogin(false);
  };

  const handleLogout = () => {

    erase("tokenAuth");
    erase("Profile");
    appDispatch({ type: "logout" });
    setAlertMessage({ open: true, message: "Logout !", alertSuccess: true });
    setLoading(false);
  };

  // localization  start

  const arLanguageHandle = (e) => {
    // // console.log("ar change");
    appDispatch({
      type: "LangChange",
      langValue: "ar",
    });
    //   i18n.changeLanguage('ar')
  };
  const enLanguageHandle = (e) => {
    // // console.log("en change");

    appDispatch({
      type: "LangChange",
      langValue: "en",
    });
  };



  const handleClickOpenQrCode = () => {

    appDispatch({
      type: "setShareInvoiceQrcode",
      shareInvoiceQrcode: true,
    });
  };

  const handleCloseQrCode = () => {
    setOpen(false);
  };
  useEffect(() => {
    qrCode.append(ref.current);

  }, [handleClickOpenQrCode]);

  useEffect(() => {
       handleClickOpenQrCode()
  }, [])
  

  useEffect(() => {
    qrCode.update({
      data: url
    });
  }, [url]);

  const onUrlChange = (event) => {
    event.preventDefault();
    setUrl(event.target.value);

  };

  const onDownloadClick = () => {
    qrCode.download({
      extension: fileExt
    });
  };

  useEffect(() => {


    setUrl(window.location.href);


  }, []);

  const handleCopyText = () => {
    var copyText = document.getElementById("myInput");
    copyText.select();
    copyText.setSelectionRange(0, 99999);
    navigator.clipboard.writeText(copyText.value);
  }



  return (
    <div className={`storeBannerv2 classForQrcodeStyling ${appState.langValue === "ar" ? "directionRtl" : ""}`}>
      {/* <div>
        <Dialog
          open={open}
          TransitionComponent={Transition}
          keepMounted
          onClose={handleCloseQrCode}
          aria-describedby="alert-dialog-slide-description"

        >
          <div className="px-3 py-3 MscBannerQrcodeInner">       <div className="row px-2 ">
            <p className={`familyManrope800 mb-0 px-1 py-2  ${appState.langValue === "ar"
              ? "text-right"
              : "text-left"
              }`}  >QR Code Generated</p>
          </div>
            <div className="App  ">
              <div className="d-flex justify-content-center" ref={ref} />
              <div className=" d-flex  mt-3 inputWrapper" style={styles.inputWrapper}>
                <div className="d-flex">
                  <Tooltip title={url}>
                    <IconButton onClick={handleCopyText} onmouseout="outFunc()" size="small">
                      <ContentCopyIcon />
                    </IconButton>
                  </Tooltip>

                  <RWebShare
                    data={{
                      text: "invoice",
                      url: url,
                      title: "Share your Invoice",
                    }}
                    onClick={() => {}}
                  >
                    <IconButton size="small" className="mx-2">
                      <IosShareIcon />
                    </IconButton>
                  </RWebShare>



                </div>
                <div className="d-flex align-items-center">
                  <TextField id="myInput" label="invoice url" variant="outlined" className="inputBox" value={url} onChange={onUrlChange} style={styles.inputBox} />
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-end mt-3">
              <Button className="mx-3 cancelBtn" variant="outlined" onClick={handleCloseQrCode}
              >
                cancel
              </Button>
              <Button className="downloadBtn" variant="contained " onClick={onDownloadClick}
              >
                Download
              </Button>
            </div>



          </div>

        </Dialog>
      </div> */}
      <div className="container">
        <div className="top_nav_bar_payment my-2 ">
          <div className="row m-0 searhIcon justify-content-between align-items-center">
            <div>
              <h6 className="mb-0 familyPoppins700">  {t("invoice.invoice")}</h6>
            </div>

            {!appState.loggedIn ? (
              <div className="d-flex align-items-center ">
                {appState.langValue == "ar" ? <Button
                  onClick={(e) => enLanguageHandle(e)}
                  variant="contained"
                  className="signUpBtn mx-md-2 mx-1"
                >
                  <span className="px-2">En</span>

                </Button> : <Button
                  onClick={(e) => arLanguageHandle(e)}
                  variant="contained"
                  className="signUpBtn  mx-0"
                >
                  <span className="familyGraphikArabic mb-2">عربي</span>

                </Button>}
                <Button
                  onClick={handleClickOpenQrCode}
                  variant="contained"
                  className="signInBtnNew mx-md-2 mx-1 "
                >

                  <img src={IosShareIcon} />
                  {t("invoice.share")}

                </Button>

                <Button
                  onClick={handleClickOpenSignUp}
                  variant="contained"
                  className="signInBtnNew mx-md-2 mx-1"
                >
                  <PersonIcon className="px-1" />
                  {t("login.Login")}

                </Button>



              </div>
            ) : (
              <div className="signout-btn align-items-center">
                <span> {appState.langValue == "ar" ? <Button
                  onClick={(e) => enLanguageHandle(e)}
                  variant="contained"
                  className="signUpBtn mx-md-2 mx-1"
                >
                  <span className="px-2">En</span>

                </Button> : <Button
                  onClick={(e) => arLanguageHandle(e)}
                  variant="contained"
                  className="signUpBtn "
                >
                  <span className="familyGraphikArabic mb-2">عربي</span>

                </Button>}</span>
                <span>  <Button
                  onClick={handleClickOpenQrCode}
                  variant="contained"
                  className="signInBtnNew mx-md-2 mx-1 "
                >

                  <img src={IosShareIcon} />
                  {t("invoice.share")}

                </Button></span>
                <span>
                  <Button
                    variant="contained"
                    className="signInBtn px-1"
                    onClick={handleLogout}
                  >
                    <img src={logout} />
                    {t("invoice.logout")}
                  </Button>
                </span>

              </div>
            )}
          </div>
        </div>
      </div>


      <div className="container">
        <section id="storeInfo" className="infoCard">
          {/* <section id="info"className="col-10 offset-1"> */}
          <div className="row m-0 py-2 align-items-center">
            <div className="logoImg">
              <img
                src={
                  store.logo
                    ? `${store.logo}`
                    : `${process.env.REACT_APP_IMAGE_URL}brandLogo.png`
                }
                className="img-fluid"
                width="55"
                alt=""
              />
            </div>
            <div
              className={`infoContent px-3  ${appState.langValue === "ar"
                ? "d-flex flex-column align-items-start "
                : ""
                }`}
            >
              {/* <p className="small m-0 text-primary">Mall Based Store</p> */}
              {/* <h5 className="mb-1 familyPoppins700">
                {store.business_desc
                  ? type === "in"
                    ? store.business_desc.en
                    : store.business_desc.en
                  : "Car Wash"}
              </h5> */}

              <h4 className="mb-1 familyPoppins700 text-capitalize">
                {type === "in"
                  ? store.business_name
                  : store.business_name}
              </h4>
              {/* 
                        <h6 className="mb-1">
                          {store.business_address ? type === "in"
                            ? store.business_address
                            : store.business_address : "No. 38, Kuwait, alriqqa"}
                        </h6> */}
              {/*<p class="small">Lorem ipsum Lorem</p> */}
              <p className="m-0">
                {store.address ? store.address : ""}
              </p>
            </div>
            <div
              className={`infoIcon ${appState.langValue === "ar"
                ? "mr-auto"
                : "ml-auto"
                }`}
            >
              <CheckCircleIcon className="CheckCircleIcon" />
            </div>
          </div>


        </section>
      </div>
    </div>
  );
};
const styles = {
  inputWrapper: {
    display: "flex",
    justifyContent: "space-between",
  },
  inputBox: {
    width: "100%",
    margin: "0px"

  }
};
export default withTranslation()(MiscBannerv2);

